(function () {
  'use strict';

  var configElement = document.getElementById('OnStore2Config');
  var root = document.querySelector('[data-on-store2-cart]');
  if (!configElement || !root) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  var STORAGE_KEY = 'on_store2_cart_id';
  var PRESENTATION_STORAGE_KEY = 'on_store2_cart_presentation_v1';
  var endpoint = 'https://' + config.domain + '/api/' + config.apiVersion + '/graphql.json';
  var panel = root.querySelector('.on-store2-cart__panel');
  var itemsElement = root.querySelector('[data-on-cart-items]');
  var emptyElement = root.querySelector('[data-on-cart-empty]');
  var footerElement = root.querySelector('[data-on-cart-footer]');
  var subtotalElement = root.querySelector('[data-on-cart-subtotal]');
  var checkoutTotalElement = root.querySelector('[data-on-cart-checkout-total]');
  var checkoutButton = root.querySelector('[data-on-cart-checkout]');
  var statusElement = root.querySelector('[data-on-cart-status]');
  var remoteVariantsPromise = null;
  var cartReadyPromise = Promise.resolve();
  var cart = null;
  var busy = false;
  var lastFocusedElement = null;
  var presentationCache = null;

  var CART_FIELDS = [
    'fragment OnCartFields on Cart {',
    '  id',
    '  checkoutUrl',
    '  totalQuantity',
    '  cost {',
    '    subtotalAmount { amount currencyCode }',
    '    totalAmount { amount currencyCode }',
    '  }',
    '  lines(first: 100) {',
    '    nodes {',
    '      id',
    '      quantity',
    '      cost { totalAmount { amount currencyCode } }',
    '      merchandise {',
    '        ... on ProductVariant {',
    '          id',
    '          title',
    '          sku',
    '          image { url altText }',
    '          product { title handle featuredImage { url altText } }',
    '        }',
    '      }',
    '    }',
    '  }',
    '}'
  ].join('\n');

  function normalizeSku(value) {
    var sku = String(value || '').trim();
    return config.skuMode === 'exact' ? sku : sku.toUpperCase().replace(/^ON-/, '');
  }

  function graphQL(query, variables) {
    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': config.storefrontAccessToken
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (response) {
      if (!response.ok) throw new Error('Store 2 returned HTTP ' + response.status + '.');
      return response.json();
    }).then(function (payload) {
      if (payload.errors && payload.errors.length) {
        throw new Error(payload.errors.map(function (item) { return item.message; }).join(' '));
      }
      return payload.data;
    });
  }

  function mutationResult(data, key) {
    var result = data && data[key];
    if (!result) throw new Error('The cart could not be updated.');
    if (result.userErrors && result.userErrors.length) {
      throw new Error(result.userErrors.map(function (item) { return item.message; }).join(' '));
    }
    if (!result.cart) throw new Error('The cart is no longer available.');
    return result.cart;
  }

  function getStoredCartId() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  function storeCartId(id) {
    try {
      if (id) window.localStorage.setItem(STORAGE_KEY, id);
      else window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // The cart still works for the current page when storage is unavailable.
    }
  }

  function readPresentationMap() {
    if (presentationCache) return presentationCache;
    try {
      var stored = window.localStorage.getItem(PRESENTATION_STORAGE_KEY);
      var parsed = stored ? JSON.parse(stored) : {};
      presentationCache = parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (error) {
      presentationCache = {};
    }
    return presentationCache;
  }

  function writePresentationMap(presentationMap) {
    try {
      var entries = Object.keys(presentationMap).map(function (key) {
        return [key, presentationMap[key]];
      }).sort(function (left, right) {
        return Number(right[1].savedAt || 0) - Number(left[1].savedAt || 0);
      }).slice(0, 200);
      var limitedMap = {};
      entries.forEach(function (entry) { limitedMap[entry[0]] = entry[1]; });
      presentationCache = limitedMap;
      window.localStorage.setItem(PRESENTATION_STORAGE_KEY, JSON.stringify(limitedMap));
    } catch (error) {
      // Destination cart data remains authoritative if local presentation storage is unavailable.
    }
  }

  function textFrom(selector) {
    var element = document.querySelector(selector);
    return element ? String(element.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function contentFrom(selector) {
    var element = document.querySelector(selector);
    return element ? String(element.getAttribute('content') || '').trim() : '';
  }

  function currentSourceImage() {
    var selectors = [
      '[id^="GalleryViewer-"] .product__media-item.is-active img',
      '.product__media-item.is-active img',
      '.product__media img',
      '.product-media-container img'
    ];
    for (var index = 0; index < selectors.length; index += 1) {
      var image = document.querySelector(selectors[index]);
      if (image) {
        var url = image.currentSrc || image.src || image.getAttribute('src');
        if (url) return String(url).indexOf('//') === 0 ? window.location.protocol + url : String(url);
      }
    }
    var metaImage = contentFrom('meta[property="og:image:secure_url"]') || contentFrom('meta[property="og:image"]');
    return metaImage.indexOf('//') === 0 ? window.location.protocol + metaImage : metaImage;
  }

  function currentSourceProductTitle() {
    return textFrom('.product__title h1')
      || textFrom('h1.product__title')
      || textFrom('.product__title')
      || contentFrom('meta[property="og:title"]')
      || document.title;
  }

  function sourcePresentation(localVariant) {
    var productTitle = config.sourceTitle || currentSourceProductTitle();
    return {
      productTitle: productTitle,
      variantTitle: localVariant && localVariant.title ? localVariant.title : '',
      imageUrl: localVariant && localVariant.image || config.sourceImage || currentSourceImage(),
      imageAlt: productTitle,
      savedAt: Date.now()
    };
  }

  function storeSourcePresentation(remoteVariantId, localVariant) {
    if (!remoteVariantId) return;
    var presentationMap = readPresentationMap();
    presentationMap[String(remoteVariantId)] = sourcePresentation(localVariant);
    writePresentationMap(presentationMap);
  }

  function seedCurrentProductPresentation(lines) {
    if (!lines.length || !Array.isArray(config.localVariants)) return;
    var presentationMap = readPresentationMap();
    var changed = false;
    lines.forEach(function (line) {
      var remoteVariant = line && line.merchandise;
      if (!remoteVariant || !remoteVariant.id || !remoteVariant.sku) return;
      var localVariant = config.localVariants.find(function (candidate) {
        return normalizeSku(candidate.sku) === normalizeSku(remoteVariant.sku);
      });
      if (!localVariant) return;
      presentationMap[String(remoteVariant.id)] = sourcePresentation(localVariant);
      changed = true;
    });
    if (changed) writePresentationMap(presentationMap);
  }

  function setBusy(nextBusy, message) {
    busy = nextBusy;
    root.classList.toggle('is-busy', nextBusy);
    checkoutButton.disabled = nextBusy || !cart || !cart.totalQuantity;
    if (message) {
      statusElement.textContent = message;
      statusElement.classList.add('is-loading');
    } else if (statusElement.classList.contains('is-loading')) {
      statusElement.textContent = '';
      statusElement.classList.remove('is-loading');
    }
  }

  function showError(error) {
    var message = error && error.message ? error.message : 'Something went wrong. Please try again.';
    statusElement.classList.remove('is-loading');
    statusElement.textContent = message;
  }

  function clearStatus() {
    statusElement.classList.remove('is-loading');
    statusElement.textContent = '';
  }

  function formatMoney(money) {
    if (!money) return '';
    try {
      return new Intl.NumberFormat(config.locale || 'en', {
        style: 'currency',
        currency: money.currencyCode
      }).format(Number(money.amount));
    } catch (error) {
      return money.currencyCode + ' ' + Number(money.amount).toFixed(2);
    }
  }

  function updateHeaderCount(quantity) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var bubble = link.querySelector('.cart-count-bubble');
    if (!quantity) {
      if (bubble) bubble.remove();
      return;
    }
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      var visible = document.createElement('span');
      visible.setAttribute('aria-hidden', 'true');
      bubble.appendChild(visible);
      link.appendChild(bubble);
    }
    var count = bubble.querySelector('[aria-hidden="true"]');
    if (count) count.textContent = quantity < 100 ? String(quantity) : '99+';
  }

  function createButton(label, action, lineId) {
    var button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('data-on-cart-action', action);
    button.setAttribute('data-line-id', lineId);
    button.setAttribute('aria-label', label);
    button.textContent = action === 'increase' ? '+' : action === 'decrease' ? '−' : label;
    return button;
  }

  function renderCart(nextCart) {
    cart = nextCart || null;
    itemsElement.replaceChildren();

    var lines = cart && cart.lines ? cart.lines.nodes : [];
    seedCurrentProductPresentation(lines);
    var presentationMap = readPresentationMap();
    lines.forEach(function (line) {
      var variant = line.merchandise;
      var source = presentationMap[String(variant.id)] || {};
      var item = document.createElement('article');
      item.className = 'on-store2-cart__item';

      var remoteLineImage = variant.image || variant.product.featuredImage;
      var lineImage = source.imageUrl ? {
        url: source.imageUrl,
        altText: source.imageAlt || source.productTitle
      } : remoteLineImage;
      if (lineImage && lineImage.url) {
        var image = document.createElement('img');
        image.className = 'on-store2-cart__image';
        image.src = lineImage.url;
        image.alt = lineImage.altText || variant.product.title;
        image.width = 192;
        image.height = 192;
        image.loading = 'lazy';
        if (source.imageUrl && remoteLineImage && remoteLineImage.url) {
          image.addEventListener('error', function () {
            if (image.src !== remoteLineImage.url) image.src = remoteLineImage.url;
          }, { once: true });
        }
        item.appendChild(image);
      } else {
        var imagePlaceholder = document.createElement('div');
        imagePlaceholder.className = 'on-store2-cart__image';
        item.appendChild(imagePlaceholder);
      }

      var main = document.createElement('div');
      main.className = 'on-store2-cart__item-main';

      var title = document.createElement('p');
      title.className = 'on-store2-cart__item-title';
      title.textContent = source.productTitle || variant.product.title;
      main.appendChild(title);

      var displayedVariantTitle = source.variantTitle || variant.title;
      if (displayedVariantTitle && displayedVariantTitle !== 'Default Title') {
        var variantTitle = document.createElement('p');
        variantTitle.className = 'on-store2-cart__variant';
        variantTitle.textContent = displayedVariantTitle;
        main.appendChild(variantTitle);
      }

      var controls = document.createElement('div');
      controls.className = 'on-store2-cart__item-controls';
      var quantity = document.createElement('div');
      quantity.className = 'on-store2-cart__quantity';
      quantity.appendChild(createButton('Decrease quantity', 'decrease', line.id));
      var quantityValue = document.createElement('span');
      quantityValue.textContent = String(line.quantity);
      quantity.appendChild(quantityValue);
      quantity.appendChild(createButton('Increase quantity', 'increase', line.id));
      controls.appendChild(quantity);

      var price = document.createElement('p');
      price.className = 'on-store2-cart__item-price';
      price.textContent = formatMoney(line.cost.totalAmount);
      controls.appendChild(price);
      main.appendChild(controls);

      var remove = createButton('Remove', 'remove', line.id);
      remove.className = 'on-store2-cart__remove';
      main.appendChild(remove);
      item.appendChild(main);
      itemsElement.appendChild(item);
    });

    var hasItems = lines.length > 0;
    emptyElement.hidden = hasItems;
    footerElement.hidden = !hasItems;
    checkoutButton.disabled = busy || !hasItems;
    updateHeaderCount(cart ? cart.totalQuantity : 0);

    if (hasItems) {
      var subtotal = formatMoney(cart.cost.subtotalAmount);
      subtotalElement.textContent = subtotal;
      checkoutTotalElement.textContent = subtotal ? '• ' + subtotal : '';
    }
  }

  function openCart() {
    lastFocusedElement = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('on-store2-cart-open');
    window.requestAnimationFrame(function () { panel.focus(); });
  }

  function closeCart() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('on-store2-cart-open');
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') lastFocusedElement.focus();
  }

  function getRemoteVariants() {
    if (remoteVariantsPromise) return remoteVariantsPromise;
    var query = [
      'query OnStore2Product($id: ID!) {',
      '  product(id: $id) {',
      '    variants(first: 100) {',
      '      nodes { id sku title availableForSale }',
      '    }',
      '  }',
      '}'
    ].join('\n');

    remoteVariantsPromise = graphQL(query, { id: config.remoteProductId }).then(function (data) {
      if (!data.product) throw new Error('This product is not available in Store 2.');
      return data.product.variants.nodes;
    }).catch(function (error) {
      remoteVariantsPromise = null;
      throw error;
    });
    return remoteVariantsPromise;
  }

  function resolveRemoteVariant(localVariantId) {
    var localVariant = config.localVariants.find(function (variant) {
      return String(variant.id) === String(localVariantId);
    });
    if (!localVariant || !localVariant.sku) {
      return Promise.reject(new Error('Select an available size before adding to the cart.'));
    }

    return getRemoteVariants().then(function (variants) {
      var normalizedSku = normalizeSku(localVariant.sku);
      var matches = variants.filter(function (variant) {
        return normalizeSku(variant.sku) === normalizedSku;
      });
      if (matches.length > 1) throw new Error('This SKU is duplicated in Store 2.');
      var remoteVariant = matches[0];
      if (!remoteVariant) throw new Error('This size is not linked to Store 2.');
      if (!remoteVariant.availableForSale) throw new Error('This size is sold out in Store 2.');
      return { remoteVariant: remoteVariant, localVariant: localVariant };
    });
  }

  function fetchCart(cartId) {
    var query = CART_FIELDS + '\nquery OnCart($id: ID!) { cart(id: $id) { ...OnCartFields } }';
    return graphQL(query, { id: cartId }).then(function (data) { return data.cart; });
  }

  function createCart(merchandiseId, quantity) {
    var query = CART_FIELDS + [
      '',
      'mutation OnCartCreate($input: CartInput!) {',
      '  cartCreate(input: $input) { cart { ...OnCartFields } userErrors { field message } }',
      '}'
    ].join('\n');
    return graphQL(query, {
      input: { lines: [{ merchandiseId: merchandiseId, quantity: quantity }] }
    }).then(function (data) { return mutationResult(data, 'cartCreate'); });
  }

  function addCartLine(cartId, merchandiseId, quantity) {
    var query = CART_FIELDS + [
      '',
      'mutation OnCartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {',
      '  cartLinesAdd(cartId: $cartId, lines: $lines) {',
      '    cart { ...OnCartFields }',
      '    userErrors { field message }',
      '  }',
      '}'
    ].join('\n');
    return graphQL(query, {
      cartId: cartId,
      lines: [{ merchandiseId: merchandiseId, quantity: quantity }]
    }).then(function (data) { return mutationResult(data, 'cartLinesAdd'); });
  }

  function updateCartLine(cartId, lineId, quantity) {
    var query = CART_FIELDS + [
      '',
      'mutation OnCartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {',
      '  cartLinesUpdate(cartId: $cartId, lines: $lines) {',
      '    cart { ...OnCartFields }',
      '    userErrors { field message }',
      '  }',
      '}'
    ].join('\n');
    return graphQL(query, {
      cartId: cartId,
      lines: [{ id: lineId, quantity: quantity }]
    }).then(function (data) { return mutationResult(data, 'cartLinesUpdate'); });
  }

  function removeCartLine(cartId, lineId) {
    var query = CART_FIELDS + [
      '',
      'mutation OnCartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {',
      '  cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {',
      '    cart { ...OnCartFields }',
      '    userErrors { field message }',
      '  }',
      '}'
    ].join('\n');
    return graphQL(query, {
      cartId: cartId,
      lineIds: [lineId]
    }).then(function (data) { return mutationResult(data, 'cartLinesRemove'); });
  }

  function selectedQuantity(form) {
    var quantityInput = form.querySelector('[name="quantity"]') || document.querySelector('product-form[data-main="true"] [name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function setProductButtonLoading(form, loading) {
    var button = form.querySelector('[name="add"]');
    if (!button) return;
    button.disabled = loading;
    button.classList.toggle('loading', loading);
    var spinner = button.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.toggle('hidden', !loading);
  }

  function showProductError(form, error) {
    var wrapper = form.closest('product-form');
    var errorWrapper = wrapper && wrapper.querySelector('.product-form__error-message-wrapper');
    var errorText = errorWrapper && errorWrapper.querySelector('.product-form__error-message');
    if (errorText) errorText.textContent = error && error.message ? error.message : 'Unable to add this item.';
    if (errorWrapper) errorWrapper.hidden = false;
  }

  function addSelectedProduct(form) {
    if (busy) return;
    var variantInput = form.querySelector('[name="id"]');
    var localVariantId = variantInput && variantInput.value;
    var quantity = selectedQuantity(form);
    clearStatus();
    setProductButtonLoading(form, true);
    setBusy(true, 'Adding item…');

    Promise.all([resolveRemoteVariant(localVariantId), cartReadyPromise])
      .then(function (results) {
        var resolvedVariant = results[0];
        var remoteVariant = resolvedVariant.remoteVariant;
        storeSourcePresentation(remoteVariant.id, resolvedVariant.localVariant);
        var cartId = getStoredCartId();
        if (cartId) return addCartLine(cartId, remoteVariant.id, quantity);
        return createCart(remoteVariant.id, quantity);
      })
      .then(function (nextCart) {
        storeCartId(nextCart.id);
        renderCart(nextCart);
        clearStatus();
        openCart();
      })
      .catch(function (error) {
        showError(error);
        showProductError(form, error);
        openCart();
      })
      .finally(function () {
        setProductButtonLoading(form, false);
        setBusy(false);
      });
  }

  function changeLine(action, lineId) {
    if (busy || !cart) return;
    var line = cart.lines.nodes.find(function (item) { return item.id === lineId; });
    if (!line) return;
    setBusy(true, 'Updating cart…');
    clearStatus();

    var request;
    if (action === 'remove' || (action === 'decrease' && line.quantity <= 1)) {
      request = removeCartLine(cart.id, lineId);
    } else {
      var nextQuantity = action === 'increase' ? line.quantity + 1 : line.quantity - 1;
      request = updateCartLine(cart.id, lineId, nextQuantity);
    }

    request.then(function (nextCart) {
      renderCart(nextCart);
      clearStatus();
    }).catch(showError).finally(function () { setBusy(false); });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('product-form[data-main="true"] form, product-form[data-main="true"] form[data-type="add-to-cart-form"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addSelectedProduct(form);
  }, true);

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('[data-on-cart-close]');
    if (closeButton) {
      event.preventDefault();
      closeCart();
      return;
    }

    var headerCart = event.target.closest('#cart-icon-bubble');
    if (headerCart) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openCart();
      return;
    }

    var directSubmit = event.target.closest('[id^="SectionAtcBtn-"], [id^="StickyAtcSubmitButton-"]');
    if (directSubmit) {
      var mainForm = document.querySelector('product-form[data-main="true"] form');
      if (mainForm) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addSelectedProduct(mainForm);
      }
      return;
    }

    var lineAction = event.target.closest('[data-on-cart-action]');
    if (lineAction) {
      changeLine(lineAction.getAttribute('data-on-cart-action'), lineAction.getAttribute('data-line-id'));
      return;
    }

    var checkout = event.target.closest('[data-on-cart-checkout]');
    if (checkout && cart && cart.checkoutUrl && !busy) {
      checkout.disabled = true;
      window.location.assign(cart.checkoutUrl);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!root.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      closeCart();
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = Array.from(panel.querySelectorAll('button:not([disabled]), a[href]'))
      .filter(function (item) { return item.getClientRects().length > 0; });
    if (!focusable.length) {
      event.preventDefault();
      panel.focus();
    } else if (event.shiftKey && (document.activeElement === focusable[0] || document.activeElement === panel)) {
      event.preventDefault();
      focusable[focusable.length - 1].focus();
    } else if (!event.shiftKey && document.activeElement === focusable[focusable.length - 1]) {
      event.preventDefault();
      focusable[0].focus();
    }
  });

  var storedCartId = getStoredCartId();
  if (storedCartId) {
    cartReadyPromise = fetchCart(storedCartId).then(function (storedCart) {
      if (!storedCart) {
        storeCartId(null);
        renderCart(null);
        return;
      }
      renderCart(storedCart);
    }).catch(function () {
      storeCartId(null);
      renderCart(null);
    });
  } else {
    renderCart(null);
  }

  // The source bag CSV can have zero local inventory. Only the destination
  // availability determines whether a scoped bag may be added.
  if (config.skuMode === 'exact') {
    var mainForm = document.querySelector('product-form[data-main="true"] form');
    var mainButton = mainForm && mainForm.querySelector('[name="add"]');
    var stickyButtons = Array.from(document.querySelectorAll('[id^="SectionAtcBtn-"], [id^="StickyAtcSubmitButton-"]'));
    if (mainButton) {
      mainButton.disabled = true;
      resolveRemoteVariant(mainForm.querySelector('[name="id"]')?.value).then(function () {
        mainButton.disabled = false;
        mainButton.removeAttribute('data-unavailable');
        var label = mainButton.querySelector('.main-atc__label__text');
        if (label) label.textContent = window.variantStrings?.addToCart || 'Add to cart';
        var price = mainButton.querySelector('.main-atc-price');
        if (price) price.classList.remove('hidden');
        stickyButtons.forEach(function (button) {
          button.disabled = false;
          var stickyLabel = button.querySelector('.sticky-atc__label__text');
          if (stickyLabel) stickyLabel.textContent = window.variantStrings?.addToCart || 'Add to cart';
        });
      }).catch(function (error) {
        showProductError(mainForm, error);
      });
    }
  }
})();
